(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('FavoritesService', FavoritesService);

    FavoritesService.$inject = ['$http', '$injector', '$state', 'RequestService', 'ModalConstructor', 'AlertModalService', 'UserData', 'FavoritesData'];

    function FavoritesService($http, $injector, $state, RequestService, ModalConstructor, AlertModalService, UserData, FavoritesData) {

        var service = {
            // Api Methods
            getFavoritables: getFavoritables,
            getFavorites: getFavorites,
            saveFavorites: saveFavorites,
            deleteFavorite: deleteFavorite,
            openFavorite: openFavorite,
            // Modal Methods
            addFavoriteModalConstructor: addFavoriteModalConstructor,
            deleteFavoriteModalConstructor: deleteFavoriteModalConstructor,
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor,
        };

        return service;

        // API Methods
        function getFavoritables(userId) {
            return $http.get(favoriteApi(userId, 'favoritable')).then(responseData);
        }

        function getFavorites(userId) {
            return $http.get(favoriteApi(userId), {ignoreLoadingBar: true}).then(responseData);
        }

        function saveFavorites(favoriteId, userId) {
            return $http.put(favoriteApi(userId, favoriteId));
        }

        function deleteFavorite(favoriteId, userId) {
            return $http.delete(favoriteApi(userId, favoriteId));
        }

        // Helper functions
        function favoriteApi(userId, method) {
            userId = userId || UserData.id;
            method = userId + '/' + (method || '');
            return RequestService.apiUrl('favorites', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        // Open favorite method
        function openFavorite(action) {
            var favorite = FavoritesData[action];
            switch (favorite.type) {
                case 'modal':
                    var service = $injector.get(favorite.service);
                    service[favorite.method]();
                    break;
                case 'state':
                    $state.go(favorite.state);
                    break;
            }
        }

        // Modal Methods
        function addFavoriteModalConstructor(scope) {
            var addFavorite = {
                templateUrl: 'app/components/favorites/favorites-list.html',
                controller: 'FavoritesListController',
                controllerAs: 'vmFavoritesList',
                size: 'lg',
                backdrop: 'static',
                scope: scope
            };
            ModalConstructor.open(addFavorite);
        }

        function deleteFavoriteModalConstructor(favorite, scope) {
            var deleteFavorite = {
                templateUrl: 'app/components/favorites/favorites-delete.html',
                controller: 'FavoritesDeleteController',
                controllerAs: 'vmFavoriteDelete',
                size: 'sm',
                backdrop: 'static',
                resolve: {favorite: favorite},
                scope: scope
            };
            ModalConstructor.open(deleteFavorite);
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'favorites');
        }

        function successModalConstructor(action, isMultiple) {
            AlertModalService.success(action, isMultiple, 'favorites');
        }

    }
})();
